import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxCapitalizePipe } from '../../../pipes/onyx-capitalize.pipe';

@Component({
  selector: 'onyx-shortcuts',
  imports: [OnyxCapitalizePipe, TranslatePipe],
  templateUrl: './onyx-shortcuts.component.html',
  styleUrl: './onyx-shortcuts.component.scss',
  host: { '[class.column]': `direction() === 'column'` },
})
export class OnyxShortcutsComponent {
  public readonly action = input<string>();
  public readonly keys = input.required<string[]>();
  public readonly color = input<'gray' | 'white'>('gray');
  public readonly direction = input<'row' | 'column'>('column');
}
